import React, { Component } from 'react';
import SwiperSlider, { SwiperSlide } from "../../components/swiper";

class ServiceGallery2 extends Component{
    render(){
                
        /* service image gallery slider params*/

        const params = {
            slidesPerView : 1,
            loop: true,
            navigation: true
        };

        /* service image gallery data */

        let imageGalleryData = [
            {img: 'arboledas1.webp'},
            {img: 'arboledas2.webp'},
            {img: 'arboledas3.webp'},
            {img: 'arboledas4.webp'},
            {img: 'arboledas4.webp'},
            {img: 'arboledas5.webp'},
            {img: 'arboledas6.webp'},
            {img: 'arboledas7.webp'},
            {img: 'arboledas8.webp'}


        ];

        
        /* service image gallery component */

        let ImageGalleryDataList = imageGalleryData.map((val, i) => {
            return(
                <SwiperSlide className="service-gallery__single-slide" key={i}>
                    <div className="item">
                        <img src={`assets/img/service/${val.img}`} className="img-fluid" alt="gallery data" />
                    </div>
                </SwiperSlide>
            )
        });


        return(
            <div>
                <div className="service-gallery">
                    <SwiperSlider options={params}>
                        {ImageGalleryDataList}
                    </SwiperSlider>
                </div>
            </div>
        )
    }
}

export default ServiceGallery2;